import { Injectable, signal } from "@angular/core";
import { MessageService } from "primeng/api";
import { AppConstants } from "src/app/shared/entity/constants";
import { ErrorType } from "src/app/shared/entity/error.const";
import { ConnectionService } from "src/app/shared/services/connection/connection.service";

export interface ConsequenceRouteMetrics {
  id: string;
  items: number;
  weight: number;
  stops: number;
  tasks: number;
  chipLabel?: string;
  chipStyleClass?: string;
}

export interface ConsequenceKPI {
    taskCount: number;
    itemCount: number;
    totalWeight: number;
    stopCount: number;
}

export interface ConsequencesMetrics {
  moveTaskMetrics:ConsequenceKPI,
  sourceRoutesImpact:{
    routeId: string;
    routeLabel: string;
    routeState: string;
    metricsBeforeMove: ConsequenceKPI;
    metricsAfterMove: ConsequenceKPI;
  }[];
  targetRouteImpact:{
    routeId: string;
    routeLabel: string;
    routeState: string;
    metricsBeforeMove: ConsequenceKPI;
    metricsAfterMove: ConsequenceKPI;
  }
}

@Injectable({
  providedIn: "root",
})
export class ConsequencesDialogService {
  
  consequencesRouteMetrics = signal<ConsequencesMetrics>({} as ConsequencesMetrics);

  constructor(private connectionService: ConnectionService,
    private readonly messageService: MessageService
  ) {}

  /**
   * Fetches the consequences metrics for a task movement based on the provided parameters.
   * @param params An object containing source route IDs, target route ID, and task IDs for which to calculate consequences.
   * The method makes an HTTP POST request to the backend API and updates the `consequencesRouteMetrics` property with the response.
   * In case of an error during the API call, it logs the error and resets `consequencesRouteMetrics` to an empty object.
   */
  getConsequencesForMovement(params: {
    sourceRouteIds: string[];
    targetRouteId: string;
    taskIds?: string[];
    itemIds?: string[];
  }): void {
    const request = {
      reqType: AppConstants.POSTREQUEST,
      endUrl: `${AppConstants.ROUTES}/${AppConstants.CONSEQUENCES}`,
      directoryType: AppConstants.DP,
      data: params,
      isLoader: true,
    };
    this.connectionService.httpReq(request).subscribe(
      (response:ConsequencesMetrics) => {
        // Handle the response here
        this.consequencesRouteMetrics.set(response);
      },
      (error) => {
        // Handle error here
        this.messageService.add({
          severity: ErrorType.ERROR,
          closable: false,
          summary: "",
          detail: "Error fetching consequences metrics",
        });
        this.consequencesRouteMetrics.set({} as ConsequencesMetrics); // Reset to default on error
      },
    );
  }
}
